/* Dear eM v25.8 (Claude) — xem ảnh phân loại trên điện thoại:
   v27.9 (27/10/2026): ảnh vuốt theo tầng phân loại thấp nhất (vd. Size / Màu → 6 màu của size đang chọn, trước chỉ 2 ảnh Small/Big).
   bấm ảnh nhỏ cạnh giá trong bảng chọn phân loại → xem to, vuốt trái/phải qua các phân loại khác,
   tên phân loại nằm ngay dưới ảnh (không đè lên ảnh). Thay cho lightbox 1 ảnh của em-tts-fix.js.
   v25.9: (1) video trong ảnh sản phẩm: khi đang phát vẫn vuốt sang ảnh khác được (iOS / trình duyệt TikTok):
              video không nhận chạm, lớp .tt-video bên trên nhận chạm (bấm = phát/dừng như cũ).
          (2) ô tìm kiếm trên trang SP: gõ tới đâu hiện gợi ý tới đó (từ khoá, bộ sưu tập, sản phẩm có ảnh + giá). */
(function () {
  'use strict';
  if (window.__emVgal) return; window.__emVgal = 1;
  var css = '@media screen and (max-width:749px){' +
    'html.em-tts .tt-gal{position:fixed;inset:0;z-index:2147483300;background:rgba(0,0,0,.9);opacity:0;transition:opacity .2s}' +
    'html.em-tts .tt-gal.is-on{opacity:1}' +
    'html.em-tts .tt-gal__track{position:absolute;inset:0;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;overscroll-behavior:contain}' +
    'html.em-tts .tt-gal__track::-webkit-scrollbar{display:none}' +
    'html.em-tts .tt-gal__s{flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center;scroll-snap-stop:always;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:calc(64px + env(safe-area-inset-top)) 0 calc(52px + env(safe-area-inset-bottom));box-sizing:border-box}' +
    'html.em-tts .tt-gal__s img{display:block;width:100vw;max-width:100vw;height:auto;max-height:calc(100% - 60px);min-height:0;flex:0 1 auto;object-fit:contain;background:#fff}' +
    'html.em-tts .tt-gal__cap{flex:0 0 auto;max-width:calc(100vw - 32px);padding:8px 16px;border-radius:999px;background:#fff;color:#222;font:600 14px/1.35 var(--tt-font,inherit);text-align:center;box-shadow:0 2px 12px rgba(0,0,0,.3)}' +
    'html.em-tts .tt-gal__n{position:absolute;top:calc(23px + env(safe-area-inset-top));left:16px;color:#fff;font:600 13px/1 var(--tt-font,inherit);opacity:.9;z-index:2}' +
    'html.em-tts .tt-gal__dots{position:absolute;left:0;right:0;bottom:calc(22px + env(safe-area-inset-bottom));display:flex;justify-content:center;gap:6px;z-index:2;pointer-events:none}' +
    'html.em-tts .tt-gal__dots i{width:6px;height:6px;border-radius:3px;background:rgba(255,255,255,.4);transition:background .2s,width .2s}' +
    'html.em-tts .tt-gal__dots i.is-on{background:#fff;width:16px}' +
    'html.em-tts .tt-gal__x{position:absolute;top:calc(12px + env(safe-area-inset-top));right:12px;z-index:3;width:38px;height:38px;border-radius:50%;border:0;background:rgba(255,255,255,.18);color:#fff;display:grid;place-items:center;padding:0}' +
    'html.em-tts .tt-gal__x svg{width:20px;height:20px;stroke:currentColor;fill:none;stroke-width:2;stroke-linecap:round}' +
    /* v25.9 (1): video đang phát không chặn vuốt */
    'html.em-tts .tt-video video{pointer-events:none!important;-webkit-touch-callout:none}' +
    'html.em-tts .tt-video{touch-action:pan-x pan-y;-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}' +
    /* v25.9 (2): gợi ý tìm kiếm */
    'html.em-tts .tt-sg{margin:10px 0 0;padding:0 0 8px}' +
    'html.em-tts .tt-sg:empty{display:none}' +
    'html.em-tts .tt-sg__h{margin:12px 0 6px;font:600 12px/1.3 var(--tt-font,inherit);color:var(--tt-gray,#888);text-transform:uppercase;letter-spacing:.03em}' +
    'html.em-tts .tt-sg__q{display:flex;align-items:center;gap:10px;padding:9px 2px;border:0;background:none;width:100%;text-align:left;font:400 15px/1.35 var(--tt-font,inherit);color:var(--tt-ink,#222);text-decoration:none;cursor:pointer}' +
    'html.em-tts .tt-sg__q svg{width:16px;height:16px;flex:0 0 16px;stroke:var(--tt-gray,#888);fill:none;stroke-width:2;stroke-linecap:round}' +
    'html.em-tts .tt-sg__q b{font-weight:700}' +
    'html.em-tts .tt-sg__p{display:flex;align-items:center;gap:12px;padding:8px 0;border-top:1px solid #f1eef6;color:var(--tt-ink,#222);text-decoration:none}' +
    'html.em-tts .tt-sg__p img{width:56px;height:56px;flex:0 0 56px;border-radius:10px;object-fit:cover;background:#f6f3fa}' +
    'html.em-tts .tt-sg__p span{display:block;min-width:0}' +
    'html.em-tts .tt-sg__t{font:500 14px/1.35 var(--tt-font,inherit);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    'html.em-tts .tt-sg__pr{margin-top:3px;font:700 14px/1.2 var(--tt-font,inherit);color:var(--tt-red,#7f63bd)}' +
    'html.em-tts .tt-sg__all{display:block;margin-top:8px;padding:11px;border-radius:999px;background:#f3eefb;color:#7f63bd;text-align:center;font:600 14px/1.2 var(--tt-font,inherit);text-decoration:none}' +
    'html.em-tts .tt-sg__none{padding:12px 2px;color:var(--tt-gray,#888);font:400 14px/1.4 var(--tt-font,inherit)}' +
    '}';
  var st = document.createElement('style'); st.id = 'em-vgal'; st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var XIC = '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var VD = null;
  function vdata() {
    if (VD) return VD;
    var el = document.getElementById('em-vt-data'); if (!el) return [];
    try { VD = JSON.parse(el.textContent).v || []; } catch (e) { VD = []; }
    return VD;
  }
  function bigSrc(u) { return (u || '').replace(/([?&])width=\d+/g, '$1width=1200').replace(/_(\d+)x(\d*)\./, '.'); }
  function items(fallback) {
    var d = vdata(), fb = null, out = [], seen = {}, cur = 0;
    for (var n = 0; n < d.length; n++) if (d[n].i) { fb = d[n].i; break; }
    /* v27.9: lấy tầng phân loại THẤP NHẤT (vd. Size / Màu → các màu của size đang chọn), không phải tầng trên cùng */
    var fss = document.querySelectorAll('.tt-vsheet variant-selects .product-form__input');
    var oi = fss.length - 1, fs = oi >= 0 ? fss[oi] : null, sel = [];
    for (var k = 0; k < oi; k++) { var ck0 = fss[k].querySelector('input[type=radio]:checked'); sel[k] = ck0 ? ck0.value : null; }
    var inputs = fs ? fs.querySelectorAll('input[type=radio]') : [];
    for (var j = 0; j < inputs.length; j++) {
      var v = inputs[j].value; if (seen[v]) continue; seen[v] = 1;
      var src = null, any = null;
      for (var m = 0; m < d.length; m++) {
        if (!d[m].o || d[m].o[oi] !== v || !d[m].i) continue;
        if (!any) any = d[m].i;
        var ok = true;
        for (var q2 = 0; q2 < oi; q2++) if (sel[q2] != null && d[m].o[q2] !== sel[q2]) { ok = false; break; }
        if (ok) { src = d[m].i; break; }
      }
      if (!src) src = any;
      if (!src) { var li = fs.querySelector('label[for="' + inputs[j].id + '"] img'); src = li ? li.src : fb; }
      if (!src) continue;
      if (inputs[j].checked) cur = out.length;
      out.push({ src: bigSrc(src), name: v });
    }
    if (out.length < 2) {
      var ck = fs && fs.querySelector('input[type=radio]:checked');
      out = [{ src: fallback, name: ck ? ck.value : '' }]; cur = 0;
    }
    return { list: out, cur: cur };
  }
  function open(fallback) {
    var g = items(fallback), many = g.list.length > 1;
    var lb = document.createElement('div'); lb.className = 'tt-gal'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    var h = '<div class="tt-gal__track">', dots = '';
    g.list.forEach(function (it, i) {
      h += '<div class="tt-gal__s"><img alt="" decoding="async"' + (Math.abs(i - g.cur) > 1 ? ' loading="lazy"' : '') + '>' + (it.name ? '<div class="tt-gal__cap"></div>' : '') + '</div>';
      dots += '<i></i>';
    });
    h += '</div>';
    if (many) h += '<div class="tt-gal__n"></div><div class="tt-gal__dots">' + dots + '</div>';
    h += '<button type="button" class="tt-gal__x" aria-label="Đóng">' + XIC + '</button>';
    lb.innerHTML = h;
    var sl = lb.querySelectorAll('.tt-gal__s');
    g.list.forEach(function (it, i) {
      var im = sl[i].querySelector('img'); im.src = it.src; im.alt = it.name;
      var c = sl[i].querySelector('.tt-gal__cap'); if (c) c.textContent = it.name;
    });
    var tr = lb.querySelector('.tt-gal__track'), num = lb.querySelector('.tt-gal__n'), di = lb.querySelectorAll('.tt-gal__dots i');
    function mark() {
      var k = Math.round(tr.scrollLeft / (tr.clientWidth || 1));
      k = Math.max(0, Math.min(g.list.length - 1, k));
      if (num) num.textContent = (k + 1) + ' / ' + g.list.length;
      for (var q = 0; q < di.length; q++) di[q].classList.toggle('is-on', q === k);
    }
    document.body.appendChild(lb);
    tr.style.scrollSnapType = 'none';
    tr.scrollLeft = g.cur * tr.clientWidth;
    tr.style.scrollSnapType = '';
    mark();
    tr.addEventListener('scroll', mark, { passive: true });
    requestAnimationFrame(function () { lb.classList.add('is-on'); });
    function close() { lb.classList.remove('is-on'); setTimeout(function () { lb.remove(); }, 200); }
    lb.addEventListener('click', function (e) { if (!e.target.closest('img, .tt-gal__cap')) close(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
  }
  /* bắt click trước listener của em-tts-fix.js (đăng ký trên document) để không mở lightbox 1 ảnh cũ */
  window.addEventListener('click', function (e) {
    var im = e.target.closest && e.target.closest('.tt-vhead__img');
    if (!im || !document.documentElement.classList.contains('em-tts')) return;
    e.preventDefault(); e.stopPropagation();
    open(bigSrc(im.currentSrc || im.src));
  }, true);

  /* v25.9 (2): gợi ý khi gõ tìm kiếm (Shopify /search/suggest.json) */
  var SIC = '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.2-4.2"/></svg>';
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function vnd(p) { var n = Math.round(parseFloat(p) || 0); return n ? n.toLocaleString('vi-VN') + 'đ' : ''; }
  function thumb(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
  function hl(text, q) {
    var t = esc(text), k = q.trim(); if (!k) return t;
    var i = text.toLowerCase().indexOf(k.toLowerCase());
    return i < 0 ? t : esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + k.length)) + '</b>' + esc(text.slice(i + k.length));
  }
  function bindSearch(form) {
    if (form.__ttSg) return; form.__ttSg = 1;
    var inp = form.querySelector('input[name=q]'); if (!inp) return;
    var box = document.createElement('div'); box.className = 'tt-sg'; box.setAttribute('aria-live', 'polite');
    form.parentNode.insertBefore(box, form.nextSibling);
    var timer = 0, seq = 0, ctl = null;
    function go(q) { location.href = '/search?type=product&q=' + encodeURIComponent(q); }
    function render(q, R) {
      var h = '', qs = (R.queries || []).slice(0, 4), cs = (R.collections || []).slice(0, 3), ps = (R.products || []).slice(0, 6);
      if (qs.length) qs.forEach(function (x) { h += '<button type="button" class="tt-sg__q" data-q="' + esc(x.text) + '">' + SIC + '<span>' + (x.styled_text || hl(x.text, q)) + '</span></button>'; });
      if (cs.length) { h += '<div class="tt-sg__h">Bộ sưu tập</div>'; cs.forEach(function (c) { h += '<a class="tt-sg__q" href="' + esc(c.url) + '">' + SIC + '<span>' + hl(c.title, q) + '</span></a>'; }); }
      if (ps.length) {
        h += '<div class="tt-sg__h">Sản phẩm</div>';
        ps.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var pr = vnd(p.price_min || p.price), many = p.price_max && p.price_min && p.price_max !== p.price_min;
          h += '<a class="tt-sg__p" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(thumb(img)) + '" alt="" loading="lazy">' : '') + '<span><span class="tt-sg__t">' + hl(p.title, q) + '</span>' + (pr ? '<span class="tt-sg__pr">' + (many ? 'Từ ' : '') + pr + '</span>' : '') + '</span></a>';
        });
      }
      if (!h) h = '<div class="tt-sg__none">Chưa thấy sản phẩm cho “' + esc(q) + '”. Thử từ khoá khác như: túi, pyjamas, khăn, vanity…</div>';
      else h += '<a class="tt-sg__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">Xem tất cả kết quả cho “' + esc(q) + '”</a>';
      box.innerHTML = h;
    }
    function run() {
      var q = inp.value.trim(), my = ++seq;
      if (q.length < 1) { box.innerHTML = ''; return; }
      if (ctl && ctl.abort) try { ctl.abort(); } catch (e) {}
      ctl = window.AbortController ? new AbortController() : null;
      var u = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query,collection,product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(u, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
        if (my !== seq) return;
        render(q, (j && j.resources && j.resources.results) || {});
      }).catch(function () {});
    }
    inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    box.addEventListener('click', function (e) { var b = e.target.closest('[data-q]'); if (b) { e.preventDefault(); go(b.getAttribute('data-q')); } });
    if (inp.value) run();
  }
  function scanSearch() { var f = document.querySelectorAll('form.tt-search'); for (var i = 0; i < f.length; i++) bindSearch(f[i]); }
  var scP = 0;
  if (window.MutationObserver) new MutationObserver(function () { if (scP) return; scP = 1; setTimeout(function () { scP = 0; scanSearch(); }, 150); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scanSearch); scanSearch();
})();
